<template>
  <div>
    <!-- Родитель -->
    <template v-if="item.child && item.child.length">
      <!-- RadioGroup -->
      <template v-if="item.isRadio">
        <v-checkbox
          dense
          hide-details
          class="ma-0 black--text"
          :label="item.name"
          v-model="item.isChecked"
        ></v-checkbox>
        <v-radio-group
          dense
          hide-details
          class="mt-0"
          :class="{'black--text':item.isChecked}"
          :disabled="!item.isChecked"
          v-model="item.balls"
        >
          <AuditItem
            v-for="child in item.child"
            :item="child"
            :key="child.id"
          ></AuditItem>
        </v-radio-group>
      </template>
      <!-- Обычный родитель -->
      <template v-else>
        <span
          :class="{'font-weight-medium':item.parentID==null}"
          class="primary--text"
        >{{item.name}}</span>
        <AuditItem
          v-for="child in item.child"
          :item="child"
          :key="child.id"
        ></AuditItem>
      </template>
    </template>
    <template v-else>
      <!-- Потомок - radio - биндим на кол-во баллов -->
      <v-radio
        v-if="item.isRadio"
        class="ma-0"
        :label="item.name"
        :value="item.id"
      ></v-radio>
      <!-- Потомок - check - биндим на isChecked -->
      <v-checkbox
        v-else
        dense
        hide-details
        class="ma-0 pt-0 pb-1 black--text"
        :label="item.name"
        v-model="item.isChecked"
      ></v-checkbox>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AuditItem',
  props: {
    item: Object
  }
}
</script>

<style scoped>
.black--text /deep/ label {
  color: black;
}
</style>
